import { useParams } from 'react-router-dom';
import {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import { API_SOLUTION_POST_ADX_TABLES } from '../../constants';
import solutionsStore, { useCurrentSolutionName } from '../../redux';
import SolutionAdxTableEditModal from './SolutionAdxTableEditModal';
import { SolutionAdxTablesItem } from '../../types';

type Props = {
  item: SolutionAdxTablesItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionAdxTableCreateContainer({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();
  const actions = useStoreUnitActions(solutionsStore);

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generateApiPath(API_SOLUTION_POST_ADX_TABLES, { solutionId }),
        params,
      }),
    (res, params) => {
      showAlert({
        type: AlertType.Success,
        title: 'ADX Table created',
        text: `${params?.tableName} ADX Table has been created successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.adxMappedTables(solutionId);
    }
  );

  return (
    <SolutionAdxTableEditModal
      title="Create New ADX Table"
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
}

export default SolutionAdxTableCreateContainer;
